import { authEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import type { MessageResponseType, ResetPasswordRequestType } from "@/types";

export const resetPasswordHandler = async ({
    email,
    password,
    passwordConfirmation,
    token,
}: ResetPasswordRequestType): Promise<MessageResponseType> => {
    const response = await axiosClient.post<MessageResponseType>(
        authEndpoints.resetPassword,
        {
            email,
            password,
            passwordConfirmation: passwordConfirmation,
            token,
        },
    );

    return { message: response.data.message };
};
